import {
  BlockStack,
  Card,
  FormLayout,
  SkeletonBodyText,
  SkeletonDisplayText,
} from "@shopify/polaris";

const FieldSkeleton = () => (
  <BlockStack gap="200">
    <SkeletonDisplayText size="small" />
    <SkeletonBodyText lines={1} />
  </BlockStack>
);

/** Loading placeholder for the fuel report create/edit modal form. */
export default function FuelReportFormSkeleton() {
  return (
    <FormLayout>
      <BlockStack gap="400">
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
        <Card>
          <BlockStack gap="300">
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText lines={4} />
          </BlockStack>
        </Card>
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
      </BlockStack>
    </FormLayout>
  );
}
